<script  lang="ts" setup>
/**
 * UI-kit component
 * Category: Buttons
 * Name: 'Text big'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=314-105800&m=dev'
 */
import { IconContainer } from '@shared/ui/icon'

defineOptions({
  name: 'BtnText',
})

withDefaults(defineProps<BtnTextProps>(), {
  text: '',
  disabled: false,
  color: 'blue',
  size: 'medium',
  elementWidth: 'auto',
})

const emit = defineEmits<{
  click: []
}>()

interface BtnTextProps {
  text?: string
  disabled?: boolean
  color?: 'blue' | 'gray'
  size?: 'medium' | 'small'
  elementWidth?: 'auto' | 'full'
}
const handleClick = (): void => {
  emit('click')
}
</script>

<template>
  <button
    type="button"
    :class="['ui-btn-text', color, size, elementWidth]"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer
      v-if="$slots.iconLeft"
      :class="[`container-${size}`]"
    >
      <slot name="iconLeft" />
    </IconContainer>
    <span
      v-if="text"
      class="ui-btn-text__text"
    >
      {{ text }}
    </span>
    <IconContainer
      v-if="$slots.iconRight"
      :class="[`container-${size}`]"
    >
      <slot
        name="iconRight"
      />
    </IconContainer>
  </button>
</template>

<style scoped lang="scss" src="./BtnText.scss" />
